import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  linkContainer: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  },
  link: {
    fontSize: 14,
    padding: theme.spacing(1),
    textAlign: 'center',
    textDecoration: 'none',
    color: theme.palette.shades.shade02,
    '&:hover': {
      opacity: '0.8',
    },
    '&:first-of-type': {
      paddingLeft: 0,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
}))

const E3dcLinks: React.FC<unknown> = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <div className={classes.linkContainer}>
      <a href={'https://www.e3dc.com/'} target={'_blank'} rel="noreferrer" className={classes.link}>
        {t('framework.e3dcHomepage')}
      </a>
      <a href={'https://www.e3dc.com/impressum/'} target={'_blank'} rel="noreferrer" className={classes.link}>
        {t('framework.imprint')}
      </a>
    </div>
  )
}

export default E3dcLinks
